import React from "react";
import { Dialog, DialogContent, DialogContentText } from "@mui/material";
import i18n from "../i18n-config";
import theme from "../theme/theme";
import { capitalizeFirstLetter } from "../utils/strings";
import CustomButton from "./CustomButton";
import { useDispatch } from "react-redux";
import { toggleSessionExpired } from "../store/utils/uiSlice";

interface Props {
  visible: boolean;
}

export default function SessionExpiredModal({ visible }: Props) {
  const dispatch = useDispatch();

  const onConnect = () => {
    dispatch(toggleSessionExpired({payload: false}));
    dispatch({type: "USER_LOGGED_OUT"})
  };

  return (
    <Dialog
      open={visible}
      keepMounted
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent>
        <DialogContentText
          id="alert-dialog-slide-description"
          textAlign={"center"}
          variant="h6"
        >
          {i18n.t("session_expire")}
        </DialogContentText>
        <DialogContentText
          id="alert-dialog-slide-description"
          textAlign={"center"}
          mt={1}
        >
          {i18n.t("session_expire_desc")}
        </DialogContentText>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 30,
          }}
        >
          <CustomButton
            title={capitalizeFirstLetter(i18n.t("se_connecter"))}
            rootStyle={{
              width: "100%",
            }}
            onClick={onConnect}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
